<template>
  <DashboardTemplate :navMenu="true">
    <div class="text-left pd-b-3">
      <h2 class="mg-less">จัดการหลักสูตร</h2>
    </div>
    <div class="pd-b-3 flex-display js-between ai-center">
      <div>
        <p v-if="showSearch" class="mg-y-less">
          <span class="text-weight-600">ค้นหา</span>
          “{{ searchText }}”
        </p>
      </div>

      <div class="flex-display">
        <el-form @submit.prevent.native ref="formSignin">
          <el-input
            placeholder="ค้นหาหลักสูตร"
            prefix-icon="el-icon-search"
            class="search-input"
            @blur="showInputSearch = false,!searchText && showSearch?search():null"
            @keyup.enter.native="search"
            @clear="searchText = '',search()"
            :class="{ show: showInputSearch }"
            ref="search"
            clearable
            v-model="searchText"
          ></el-input>

          <el-button
            v-if="!showInputSearch"
            @click="openSearchInput"
            icon="el-icon-search"
            round
            class="pd-x-2 primary border-color-primary"
            >ค้นหา</el-button
          >
        </el-form>
        <el-button
          @click="$router.push('/manage/course/create')"
          type="primary"
          class="mg-l-4"
          round
          >เพิ่มหลักสูตร</el-button
        >
      </div>
    </div>
    <div>
      <el-table
        v-if="showTable"
        :data="courseList"
        border
        :header-row-style="tableHeaderStyle"
        :header-cell-style="tableHeaderStyle"
        v-loading="loading"
        empty-text="ไม่พบข้อมูล"
      >
        <el-table-column
          type="index"
          label="ลำดับ"
          header-align="center"
          align="center"
          width="80"
          :index="(index) => indexMethod(index, page, pageSize)"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="ชื่อหลักสูตร"
          header-align="center"
          sortable
          :width="widthMax < 767.98 ? '170' : ''"
        >
          <template slot-scope="scope">
            <div class="flex-display js-between ai-center">
              <span>{{scope.row.name}}</span>
              <el-tooltip v-if="!scope.row.preTest" class="item" effect="dark" content="กรุณาเพิ่มแบบทดสอบก่อนเรียน"  placement="bottom">
                <i class="fas fa-exclamation-triangle color-danger-light"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="durationTime"
          label="ระยะเวลาในการเปิด-ปิดหลักสูตร"
          width="350"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope"
            >{{ scope.row.durationTime.open | dateTimeThShort }} -
            {{ new Date(scope.row.durationTime.close).setHours(23,59,59) | dateTimeThShort }}</template
          >
        </el-table-column>
        <el-table-column
          prop="subject"
          label="จำนวนวิชา"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{ scope.row.subject.length }}</template>
        </el-table-column>
        <el-table-column
          prop="updatedAt"
          label="วันที่อัปเดตล่าสุด"
          header-align="center"
          align="center"
          sortable
          :width="widthMax < 767.98 ? '130' : '250'"
        >
          <template slot-scope="scope">{{
            scope.row.updatedAt | dateTimeTh
          }}</template>
        </el-table-column>
        <el-table-column label width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex-display ai-center js-center">
              <div class="box-action">
                <div
                  @click="
                    $router.push(
                      `/manage/course/update?courseId=${scope.row._id}`
                    )
                  "
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-pen"></i>
                </div>
              </div>
              <div class="box-action">
                <el-popconfirm
                  confirmButtonText="ใช่"
                  cancelButtonText="ไม่"
                  icon="el-icon-info"
                  iconColor="red"
                  title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                  @onConfirm="delCourse(scope.row._id)"
                >
                  <div slot="reference" class="circle-action color-bg-danger-lighter">
                    <i class="fas fa-trash-alt"></i>
                  </div>
                </el-popconfirm>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div  v-if="totalCourse > pageSize" class="pd-y-3">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="totalCourse"
        :page-size="pageSize"
        :current-page="page"
      ></el-pagination>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import { tableHeaderStyle } from "@/service/table";
import { HTTP } from "@/service/axios.js";

export default {
  routeParams: {
    type: Object,
    default: null,
  },
  components: {
    DashboardTemplate,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      courseList: [],
      searchText: "",
      showInputSearch: false,
      page: 1,
      pageSize: 10,
      totalCourse: 0,
      loading: true,
      showSearch: false,
    };
  },
  mounted() {
    this.fetchCourse();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    delCourse(id) {
      this.loading = true;
      let obj = {
        courseId: id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`delete/course`, obj)
        .then((res) => {
          if (res.data.success) {
            this.fetchCourse();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    openSearchInput() {
      this.showInputSearch = true;
      if (!this.showSearch) {
        this.searchText = "";
      }

      setTimeout(() => {
        this.$refs.search.focus();
      }, 500);
    },
    fetchCourse() {
      HTTP.get(
        `course/${(this.page - 1) * this.pageSize}/${this.pageSize}/${
          this.searchText != "" ? this.searchText : "all"
        }`
      )
        .then((res) => {
       
          if (res.data.success) {
            this.courseList = res.data.obj;
            this.totalCourse = res.data.count;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    changePage(page) {
      this.page = page;
      this.fetchCourse();
    },
    search() {
      this.loading = true;
      this.page = 1
      this.fetchCourse();
      if (this.searchText != "") {
        this.showSearch = true;
      } else {
        this.showSearch = false;
      }
    },
  },
};
</script>

<style scoped></style>
